import { render, staticRenderFns } from "./PortalStatusCard.vue?vue&type=template&id=144d937a&scoped=true&"
import script from "./PortalStatusCard.vue?vue&type=script&lang=js&"
export * from "./PortalStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./PortalStatusCard.vue?vue&type=style&index=0&id=144d937a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d937a",
  null
  
)

export default component.exports